import React, { useState } from "react";

import { DropMetricProps } from "./types";

import {
  List,
  Label,
  Filter,
  Disabled,
  Selected,
  ListItem,
  Container,
  OneList,
} from "./styles";

import arrowSource from "application/assets/images/icons/arrow-down.svg";
import acceptSource from "application/assets/images/icons/green-accept.svg";
import OptionalTooltip from "../OptionalTooltip";
import {MetricItem} from "../../../common/home/store/model";

const DropMetricsGroup = ({
  data,
  label,
  disabled,
  selected,
  placeholder,
  onSelect,
  tooltip
}: DropMetricProps) => {
  const [visible, setVisible] = useState(false);

  const toggleVisible = () => setVisible(!visible);

  const handleSelect = (item: MetricItem) => {
    const currentSelected = selected || [];
    const isAlreadySelected = currentSelected.some((s) => s.code === item.code);

    let newSelected: MetricItem[];
    if (isAlreadySelected) {
      newSelected = currentSelected.filter((s) => s.code !== item.code);
    } else {
      newSelected = [...currentSelected, item];
    }

    onSelect(newSelected);
  };

  const renderSelectedText = () => {
    const currentSelected = selected || [];
    if (currentSelected.length === 0) {
      return placeholder;
    }

    return currentSelected.map((item) => item.displayName).join(", ");
  };

  const renderList = () => {
    return (
      <OneList>
        {data?.map((item) => {
          const isSelected = selected?.some((s) => s.code === item.code);
          return (
            <ListItem
              key={item.code}
              isSelected={isSelected}
              onClick={() => handleSelect(item)}
            >
              <p>{item.displayName}</p>
              {isSelected && <img src={acceptSource} alt="accept" />}
            </ListItem>
          );
        })}
      </OneList>
    )
  };

  return (
    <div className="drop-group-wrapper">
      <OptionalTooltip text={tooltip || ''}><Label className="drop-group-label">{label}</Label></OptionalTooltip>
      <Container visible={visible} className="drop-group-container">
        {disabled && <Disabled />}
        <Selected onClick={toggleVisible} className="drop-group-selected">
          <p>{renderSelectedText()}</p>
          <img src={arrowSource} alt="arrow" />
        </Selected>
        {visible && <List>{renderList()}</List>}
      </Container>
      {visible && <Filter onClick={toggleVisible} />}
    </div>
  );
};

export default DropMetricsGroup;
